var map = {
	"./Asura_tango_icon_20px.png": 2898,
	"./Charr_tango_icon_20px.png": 8394,
	"./Human_tango_icon_20px.png": 6827,
	"./Norn_tango_icon_20px.png": 61,
	"./Sylvari_tango_icon_20px.png": 9604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4986;